import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Layout from './views/Layout'
import TestLayout from './views/TestLayout'
import Login from './components/Login'
import Register from './views/Register'
import CreateUsers from './views/CreateUsers'
import Users from './views/Users'
import ManageUsers from './views/ManageUsers'
import Groups from './views/Groups'
import Levels from './views/Levels'
import Categories from './views/Categories'
import SubCategories from './views/SubCategories'
import Questions from './views/Questions'
import Exams from './views/Exams'
import LanTest from './views/LanTest'
import Profile from './views/Profile'
import IndividualTestResults from './views/IndividualTestResults'
import GlobalTestResults from './views/GlobalTestResults'
import CheckLanTest from './views/CheckLanTest'
import RegisterCode from './components/RegisterCode'
import Students from './views/Students'
import X from './views/x'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        default: Layout,
        main: Home
      }
    },
    {
      path: '/test/',
      name: 'test',
      component: Layout
    },
    {
      path: '/login',
      name: 'login',
      components: {
        default: Login
      }
    },
    {
      path: '/register-code',
      name: 'register-code',
      components: {
        default: RegisterCode
      }
    },
    {
      path: '/register',
      name: 'register',
      props: (route) => ({ token: route.query.token }),
      components: {
        default: Layout,
        main: Register
      }
    },
    {
      path: '/manage/usersadmin',
      name: 'usersadmin',
      components: {
        default: Layout,
        main: Users
      }
    },
    {
      path: '/manage/users',
      name: 'manageUsers',
      components: {
        default: Layout,
        main: ManageUsers
      }
    },
    {
      path: '/manage/questions',
      name: 'questions',
      components: {
        default: Layout,
        main: Questions
      }
    },
    {
      path: '/user/lanTest',
      name: 'lanTest',
      props: (route) => ({ id: route.query.id }),
      components: {
        default: TestLayout,
        main: LanTest
      }
    },
    {
      path: '/user/checkLanTest',
      name: 'checkLanTest',
      props: (route) => ({ id: route.query.id }),
      components: {
        default: Layout,
        main: CheckLanTest
      }
    },
    {
      path: '/user/profile',
      name: 'profile',
      components: {
        default: Layout,
        main: Profile
      }
    },
    {
      path: '/user/indiv-results',
      name: 'indiv-results',
      props: (route) => ({ id: route.query.id }),
      components: {
        default: Layout,
        main: IndividualTestResults
      }
    },
    {
      path: '/user/global-results',
      name: 'global-results',
      components: {
        default: Layout,
        main: GlobalTestResults
      }
    },
    {
      path: '/manage/exams',
      name: 'exams',
      components: {
        default: Layout,
        main: Exams
      }
    },
    {
      path: '/manage/groups',
      name: 'groups',
      components: {
        default: Layout,
        main: Groups
      }
    },
    {
      path: '/manage/students-info',
      name: 'students',
      components: {
        default: Layout,
        main: Students
      }
    },
    {
      path: '/manage/levels',
      name: 'levels',
      components: {
        default: Layout,
        main: Levels
      }
    },
    {
      path: '/manage/categories',
      name: 'categories',
      components: {
        default: Layout,
        main: Categories
      }
    },
    {
      path: '/manage/subcategories',
      name: 'subcategories',
      components: {
        default: Layout,
        main: SubCategories
      }
    },
    {
      path: '/manage/x',
      name: 'x',
      components: {
        default: Layout,
        main: X
      }
    },
    {
      path: '/createUsers',
      name: 'createUsers',
      component: CreateUsers
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
